import { render } from "./ticketPresta.vue?vue&type=template&id=2ddc7df3"
import script from "./ticketPresta.vue?vue&type=script&lang=ts"
export * from "./ticketPresta.vue?vue&type=script&lang=ts"

import "./ticketPresta.vue?vue&type=style&index=0&id=2ddc7df3&lang=css"
script.render = render

export default script